export default "__VITE_ASSET__CWdo6V_j__"